import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { Plan } from "../../domain";

@Injectable({ providedIn: 'root' })
export class GetPlanByIdUsecase implements UseCase<string, Plan> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: string): Observable<Plan> {
    return this.planRepository.getPlanById(params);
  }

}